import {
  Customer,
  CustomerAction,
  CustomerActions,
  CustomerQueryParams
} from './../model';

export function fetchInitial(params?: CustomerQueryParams): CustomerAction {
  return {
    type: CustomerActions.FETCH_CUSTOMERS,
    payload: {
      request: {
        url: '/customers',
        method: 'GET',
        params,
      },
    },
  };
}

export function fetchMore(params?: CustomerQueryParams): CustomerAction {
  return {
    type: CustomerActions.FETCH_MORE_CUSTOMERS,
    payload: {
      request: {
        url: '/customers',
        method: 'GET',
        params,
      },
    },
  };
}

export function fetchMoreActive(params?: CustomerQueryParams): CustomerAction {
  return {
    type: CustomerActions.FETCH_MORE_CUSTOMERS,
    payload: {
      request: {
        url: '/customers/used',
        method: 'GET',
        params,
      },
    },
  };
}

export function fetchDetails(customerId: string) {
  return {
    type: CustomerActions.FETCH_DETAILS,
    payload: {
      request: {
        url: `/customers/forcustomer/${customerId}`,
        method: 'GET',
      },
    },
  };
}

export function createDummy(customerNumber: string) {
  return {
    type: CustomerActions.CREATE_DUMMY,
    payload: {
      request: {
        url: `/dummy/${customerNumber}`,
        method: 'POST',
      },
    },
  };
}

export function clearDummy(customerNumber: string) {
  return {
    type: CustomerActions.CLEAR_DUMMY,
    payload: {
      request: {
        url: `/dummy/${customerNumber}`,
        method: 'DELETE',
      },
    },
  };
}

export function selectCustomer(payload: Customer) {
  return {
    type: CustomerActions.SELECT_CUSTOMER,
    payload,
  };
}

export function fetchFilter() {
  return {
    type: CustomerActions.FETCH_CUSTOMERS_FILTER,
    payload: {
      request: {
        url: '/customers',
        method: 'GET',
      },
    },
  };
}

export function fetchWithdrawals(customerNumber: string, date?: string | null) {
  return {
    type: CustomerActions.FETCH_WITHDRAWALS,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerNumber}/withdrawals${date ? `?date=${encodeURIComponent(date)}` : ''}`,
        method: 'GET',
      },
    },
  };
}

export function fetchOldStock(customerNumber: string, before: number) {
  return {
    type: CustomerActions.FETCH_OLD_STOCK,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerNumber}/stock?before=${before}`,
        method: 'GET',
      },
    },
  };
}

export function toggleArrivalConfirmationState(
  customerNumber: string,
  itemId: number,
  eventId: number,
  charge: boolean
): CustomerAction {
  const suffix = charge ? 'charge' : 'uncharge';
  return {
    type: CustomerActions.TOGGLE_ARRIVAL_CONFIRMATION_STATE,
    payload: {
      request: {
        url: `/stock-articles/forcustomer/${customerNumber}/item/${itemId}/${suffix}/${eventId}`,
        method: 'PATCH',
      },
    },
  };
}
